import React from 'react'
import { Navigate } from 'react-router'
import { groupBy } from 'lodash'

import { PATHS } from '../constants/paths'
import { ROLES_ARRAY } from '../constants/roles'
import { HomeRedirect } from '../components/HomeRedirect'
import { routesDescriptions } from '../constants/routesDescriptions'


const splittedRoutes = groupBy(routesDescriptions, (route) => (route.isProtected === false ? 'open' : 'protected'))
export const protectedRoutes = [
  ...splittedRoutes.protected,
  // fallback as last route
  {
    link: '*',
    exact: false,
    roles: ROLES_ARRAY,
    component: HomeRedirect,
  },
]
export const openRoutes = [
  ...splittedRoutes.open,
  // fallback as last route
  {
    link: '*',
    exact: false,
    component: () => <Navigate to={PATHS.LOGIN} />,
  },
]
